document.addEventListener('DOMContentLoaded', function() {
  // TODO: Review and reduce this, the controls are now handled by the liquid snippet
  const emblaNode = document.querySelector('.ecs-product-info__media .embla');
  if (!emblaNode) return;

  const emblaApi = EmblaCarousel(emblaNode, {
    align: 'start',
    loop: false,
    containScroll: 'trimSnaps'
  });

  // Create button wrappers for positioning
  const prevWrapper = document.createElement('div');
  prevWrapper.className = 'embla__button-wrapper embla__button-wrapper--prev';

  const nextWrapper = document.createElement('div');
  nextWrapper.className = 'embla__button-wrapper embla__button-wrapper--next';

  // Create navigation buttons
  const prevButton = document.createElement('button');
  prevButton.className = 'embla__button embla__button--prev';
  prevButton.type = 'button';
  prevButton.innerHTML = `
    <svg width="15" height="29" viewBox="0 0 15 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 27.5186L2.13844 15.657C1.73575 15.2543 1.53441 15.053 1.46076 14.8201C1.3987 14.6239 1.3987 14.4133 1.46076 14.217C1.53441 13.9841 1.73575 13.7828 2.13844 13.3801L14 1.51855" stroke="#002853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const nextButton = document.createElement('button');
  nextButton.className = 'embla__button embla__button--next';
  nextButton.type = 'button';
  nextButton.innerHTML = `
    <svg width="15" height="29" viewBox="0 0 15 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1.51855L12.8616 13.3801C13.2642 13.7828 13.4656 13.9841 13.5392 14.217C13.6013 14.4133 13.6013 14.6239 13.5392 14.8201C13.4656 15.053 13.2642 15.2543 12.8616 15.657L1 27.5186" stroke="#002853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  // Add buttons to wrappers
  // prevWrapper.appendChild(prevButton);
  // nextWrapper.appendChild(nextButton);

  // Append the wrappers to the media container instead of the embla node
  const mediaContainer = document.querySelector('.embla-slides');
  mediaContainer.classList.add('has-navigation');
  mediaContainer.appendChild(prevWrapper);
  mediaContainer.appendChild(nextWrapper);

  // Add event listeners
  prevButton.addEventListener('click', () => emblaApi.scrollPrev());
  nextButton.addEventListener('click', () => emblaApi.scrollNext());

  // Function to toggle navigation visibility based on the number of visible slides
  const toggleNavigationVisibility = () => {
    // Get the currently visible slides
    const slides = emblaNode.querySelectorAll('.embla__slide');
    const visibleSlides = Array.from(slides).filter(slide =>
      slide.style.display !== 'none'
    );

    // Hide navigation if there's only one slide visible
    const shouldHideNavigation = visibleSlides.length <= 1;
    prevWrapper.style.display = shouldHideNavigation ? 'none' : '';
    nextWrapper.style.display = shouldHideNavigation ? 'none' : '';
  };

  // Run initially
  toggleNavigationVisibility();

  // Add an event listener to the variant buttons to update navigation
  const variantButtons = document.querySelectorAll('.ecs-product-info__variant-button');
  variantButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Give the DOM time to update before checking visibility
      setTimeout(toggleNavigationVisibility, 50);
    });
  });

  // Handle window resize events
  window.addEventListener('resize', toggleNavigationVisibility);
});
